import { filterCookies } from "../utils/cookie"
import identity from "ramda/src/identity"

import Routes, { DEFAULT_CLIENT_NAME } from "./routes"
import _get from "lodash/get"

function valuesOfPath(extras) {
  const keys = ["customerKey"]
  const values = filterCookies(keys)

  return { ...values, ...extras }
}

export function pathParams(name, client = DEFAULT_CLIENT_NAME, values) {
  const route = _get(Routes, `${client}.${name}`)

  try {
    return route(valuesOfPath(values))
  } catch (e) {
    console.error(`NOT FOUND ROUTE => ${client}.${name}`)
    e.message = "Unknown route name, please pass a valid one."
    throw e
  }
}

function request(name, { client = DEFAULT_CLIENT_NAME, pathValues, ...rest }) {
  const url = pathParams(name, client, pathValues)

  return { client, request: { url, ...rest } }
}

function responseExtractor(config) {
  return config.raw ? identity : extractBusinessData
}

export function extractResponseData(response) {
  if (response && response.data.protocolNumber) {
    if (response.data.resultData) {
      response.data.resultData.resultProtocol = response.data.protocolNumber
    }
  }
  return responseExtractor(response.config)(response)
}

export function get(name, config = {}) {
  return request(name, config)
}

export function post(name, config = {}) {
  return request(name, { method: "post", ...config })
}

export function put(name, config = {}) {
  return request(name, { method: "put", ...config })
}

export function patch(name, config = {}) {
  return request(name, { method: "patch", ...config })
}

// [ESLINT]: Parsing error: delete is a reserved word.
export function remove(name, config = {}) {
  return request(name, { method: "delete", ...config })
}

export const extractBusinessData = ({ data: { resultData } }) => resultData



// WEBPACK FOOTER //
// ./src/services/network/endpoint.js